__turbopack_context__.v({
  "container": "FilePreview-module-scss-module__szTAmW__container",
  "fileName": "FilePreview-module-scss-module__szTAmW__fileName",
  "iconWrapper": "FilePreview-module-scss-module__szTAmW__iconWrapper",
  "removeButton": "FilePreview-module-scss-module__szTAmW__removeButton",
});
